export const truckInfo = reactive({
  capacity: null,
  chassis_number: '',
  engine_number: '',
  routes: [],
  truck_number: null,
  tyres: null,
  mapped_tyres: null,
  truck_length: '',
  l: null,
  w: null,
  h: null,
})

export const trucksHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Truck No.', key: 'truck_number' },
  { title: 'Tyres', key: 'tyres', align: 'start' },
  { title: 'LWH (ft)', key: 'lwh', align: 'start', sortable: false },
  { title: 'Capacity', key: 'capacity', align: 'start' },
  { title: 'Chassis No.', key: 'chassis_number', align: 'start', sortable: false },
  { title: 'Engine No.', key: 'engine_number', align: 'start', sortable: false },
  { title: 'Doc. Verification', key: 'is_docs_verified', align: 'start' },
  { title: 'Status', key: 'is_active', align: 'start' },
  { title: 'Created Timestamp', key: 'created_at', align: 'start' },
  { title: 'Updated Timestamp', key: 'updated_at', align: 'center' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const truckSearchFields: any = reactive({
  id: '',
  truck_number: '',
  chassis_number: '',
  tyres: '',
  length: '',
  capacity: null,
  engine_number: '',
  is_docs_verified: '',
  is_active: '',
})

export const resetTruckFields = { ...truckSearchFields }
